import Button from '../../../Button'
import { useTourContext } from '../../../../context/TourContext'
import { FaXmark, FaCaretLeft, FaCaretRight } from 'react-icons/fa6'
import { useEffect } from 'react'

const TourCardContent = ({
  content,
  totalSteps,
  currentStep,
  hideNextButton,
  hidePrevButton,
  onClose,
}) => {
  const { onCloseTutorial, handleNextTourStep, handlePrevTourStep } =
    useTourContext()

  const isLastStep = currentStep + 1 === totalSteps

  return (
    <div
      className="relative flex flex-col gap-2 justify-start lg:p-[25px] lg:max-w-[360px] max-w-[200px] p-[10px]"
      id="tour-card"
    >
      <div
        className="lg:text-[1.1rem] text-[0.8rem] text-white pt-4 lg:leading-5 leading-[0.9rem]"
        dangerouslySetInnerHTML={{ __html: content }}
      />
      <button
        className="absolute lg:top-[10px] lg:right-[10px] top-[5px] right-[5px] scale-75"
        onClick={onClose}
        id="close-modal-icon"
      >
        <FaXmark />
      </button>

      <div className="flex flex-row gap-[8px] mt-[5px]">
        {!hidePrevButton && (
          <Button
            onClick={handlePrevTourStep}
            id="tour-card-prev-btn"
            className="bg-primary-darker lg:!w-[32px] lg:!h-[32px] !w-[26px] !h-[26px] lg:!p-[7px] !p-[6px]"
          >
            <FaCaretLeft className="w-full h-full" />
          </Button>
        )}
        {!hideNextButton && (
          <Button
            onClick={handleNextTourStep}
            id="tour-card-next-btn"
            className="bg-primary-darker lg:!w-[32px] lg:!h-[32px] !w-[26px] !h-[26px] lg:!p-[7px] !p-[6px]"
          >
            <FaCaretRight className="w-full h-full" />
          </Button>
        )}
      </div>

      {isLastStep ? (
        <div className="justify-start items-start">
          <Button
            onClick={onCloseTutorial}
            id="tour-card-finish-btn"
            className="bg-primary-darker text-white mt-2"
          >
            Închide
          </Button>
        </div>
      ) : null}
    </div>
  )
}

export default TourCardContent
